import Dot from 'dot-object'
import _ from "lodash";
import {Divider, Select, Space} from "antd";
import {Fragment} from "react";
import currencies from "currencies.json"

import fr from "./fr.json"
import en from "./en.json"
import he from "./he.json"
import it from "./it.json"
import ru from "./ru.json"
import pt from "./pt.json"


// Drapeaux servis localement via le package `flag-icons` (CSS importé dans
// pages/_app.js). Remplace l'ancien service externe flagsapi.com qui tombait
// par intermittence. `code` est un code ISO 3166-1 alpha-2 (cf. LANGS.flag),
// flag-icons attend la version minuscule.
const Flag = ({code, size = 26}) => (
    <span
        className={"fi fi-" + String(code || "").toLowerCase()}
        style={{
            width: size,
            height: Math.round(size * 0.78),
            borderRadius: 5,
            backgroundSize: "cover",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.12)",
            verticalAlign: "middle",
        }}
    />
)


export const getDeviseName = (context,forceDevise=null) => {
    const devise=forceDevise || context.org.devise || "eur"
    return currencies.currencies.find(i=>i.code===devise.toUpperCase())?.name
}

export const getDeviseSymbol = (context,forceDevise=null) => {
    const devise=forceDevise || context.org.devise || "eur"
    return currencies.currencies.find(i=>i.code===devise.toUpperCase())?.symbol
}

export const getCurrencyFormater = (context) => {
    const devise=context.org.devise || "eur"
    const language=context?.langValue || context.org.language || "fr"

    return (amount,mfd=0,_devise=null)=>new Intl.NumberFormat(language, {
        style: 'currency',
        currency: _devise?.toUpperCase() || devise.toUpperCase(),
        minimumFractionDigits:mfd
    }).format(amount)
}

export function LangSelect({context,light,full})
{
    const {org,lang}=context

    const defaultLanguage=org.language || "fr"

    // Auto-détection langue déléguée à RouterService côté serveur (Accept-Language header).

    if(!Array.isArray(org.languages) || org.languages.length===0){
        return null
    }

    const availableLangs=LANGS.filter(i=>org.languages.includes(i.value))

    const onChange=(key)=>{
        const base=org.BASE_WEB_URL.split("/")
        const route=context.route
        let query=[]
        for(let q of Object.keys(context.query).filter(i=>i!=="router")){
            query.push(q+"="+context.query[q])
        }


        const lastBase=base[base.length-1]
        if(LANGS.find(i=>i.value===lastBase)){
            base[base.length-1]=key
        }else{
            base.push(key)
        }

        let url=base.concat(route).join("/")
        if(query.length>0){
            url+="?"+query.join("&")
        }
        console.log("onChange lang",key,url)
        window.location.href=url
    }


    const defaultLang=LANGS.find(i=>i.value===defaultLanguage)


    if(light)
    {
        return(
            <li style={{height:55,display:"flex",justifyContent:"center",alignItems:"center"}}>
                <Select style={{margin:0}} suffixIcon={null} dropdownStyle={{zIndex: 100000}} defaultValue={lang?.value || defaultLanguage}
                        onChange={onChange} >
                    <Select.Option value={defaultLang.value}><Flag code={defaultLang.flag}/></Select.Option>
                    {availableLangs.map(i => {
                        return (
                            <Select.Option key={i.value} value={i.value}><Flag code={i.flag}/></Select.Option>
                        )
                    })}
                </Select>
            </li>
        )
    }

    if(full)
    {
        return(
            <Select dropdownStyle={{zIndex:100000}} size={"large"} defaultValue={lang?.value || defaultLanguage} onChange={onChange}>
                <Select.Option value={defaultLang.value}><Space align="center"><Flag code={defaultLang.flag}/> {defaultLang.formatLabel}</Space></Select.Option>
                {availableLangs.map(i=>{
                    return(
                        <Select.Option key={i.value} value={i.value}><Space align="center"><Flag code={i.flag}/> {i.formatLabel}</Space></Select.Option>
                    )
                })}
            </Select>
        )
    }

    return (
        <Fragment>
        <li style={{display:"flex",justifyContent:"center"}}>
            <Select dropdownStyle={{zIndex:100000}} size={"large"} defaultValue={lang?.value || defaultLanguage} onChange={onChange}>
                <Select.Option value={defaultLang.value}><Space align="center"><Flag code={defaultLang.flag}/> {defaultLang.formatLabel}</Space></Select.Option>
                {availableLangs.map(i=>{
                    return(
                        <Select.Option key={i.value} value={i.value}><Space align="center"><Flag code={i.flag}/> {i.formatLabel}</Space></Select.Option>
                    )
                })}
            </Select>
        </li>
        <li>
            <Divider/>
        </li>
        </Fragment>
    )
}

export const SYSTEMLANGS={
    fr:Dot.dot(fr),
    en:Dot.dot(en),
    he:Dot.dot(he),
    it:Dot.dot(it),
    ru:Dot.dot(ru),
    pt:Dot.dot(pt),
}


export const useTranslator=(context)=>{
    const langId=context?.lang?.value || context?.org?.language || "fr"
    const defaultData=SYSTEMLANGS["fr"]
    const data=SYSTEMLANGS[langId] || defaultData
    //console.log("useTranslator",langId,data)
    return (key)=>{
        if(data[key]){
            return data[key]
        }
        return key
    }
}


export function translate(key,langId="fr")
{
    const defaultData=SYSTEMLANGS["fr"]
    const data=SYSTEMLANGS[langId] || defaultData
    if(data[key]){
        return data[key]
    }
    return key
}



//CONTENT LANGUAGES
export const LANGS=[
    {label:"Francais",value:"fr",formatLabel:"Francais",flag:"FR",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Anglais",value:"en",formatLabel:"English",flag:"US",currencyData:{id:"USD",symbol:"$",rate:0.93}},
    {label:"Hebreu",value:"he",formatLabel:"עברית",flag:"IL",currencyData:{id:"ILS",symbol:"₪",rate:0.26}},
    {label:"Italien",value:"it",formatLabel:"Italiano",flag:"IT",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Russe",value:"ru",formatLabel:"Русский",flag:"RU",currencyData:{id:"RUB",symbol:"₽",rate:0.010}},
    {label:"Portugais",value:"pt",formatLabel:"Português",flag:"PT",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Allemand",value:"de",formatLabel:"Deutsch",flag:"DE",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Espagnol",value:"es",formatLabel:"Español",flag:"ES",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Grec",value:"gr",formatLabel:"ελληνικά",flag:"GR",currencyData:{id:"EUR",symbol:"€",rate:1}},
    {label:"Roumain",value:"ro",formatLabel:"Română",flag:"RO",currencyData:{id:"EUR",symbol:"€",rate:1}},
]

export function applyI18n(object,context){
    object=applyDevise(object,context.org.devise)
    object=applyLang(object,context.lang)
    object=applyDevise(object,context.org.devise)

    return object
}

export function applyDevise(object,devise){
    if(!devise || !object || !object[devise]){
        return object
    }

    let dataDevise=object[devise]
    let dataMerge={}
    for(let k of Object.keys(dataDevise)){
        const finalValue=checkValue(dataDevise[k])
        if(finalValue){
            dataMerge[k]=finalValue
        }
    }

    return _.merge({},object,dataMerge)
}

export function applyLang(object,lang){
    if(!lang || !lang?.value || !object || !object[lang?.value]){
        return object
    }

    let dataLang=object[lang.value]
    let dataMerge={}
    for(let k of Object.keys(dataLang)){
        const finalValue=checkValue(dataLang[k])
        if(finalValue){
            dataMerge[k]=finalValue
        }
    }

    return _.merge({},object,dataMerge)
}

function checkValue(value){
    if(Array.isArray(value)){
        const translated=[]
        value.forEach((item,index)=>{
            const result=checkValue(item)
            if(result) translated[index]=result
        })
        return translated
    }

    if(value && typeof value === "object"){
        let object={}
        for(let k of Object.keys(value)){
            const v=checkValue(value[k])
            if(v){
                object[k]=v
            }
        }
        return object
    }

    if(typeof value === "string"){
        value=value.trim()
    }

    if(value){
        return value
    }

    return null
}

export function getCurrencyData(lang){
    return LANGS.find(i=>i.value==="fr")?.currencyData
    /*
    const _lang=lang?.value || "fr"
    return LANGS.find(i=>i.value===_lang)?.currencyData
     */
}
